import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEFAULT_TITLE = 'Tribal Dash — Cannabis Delivery in The Hamptons';

const TITLES = {
  '/': DEFAULT_TITLE,
  '/menu': 'Shop Menu | Tribal Dash',
  '/checkout': 'Checkout | Tribal Dash',
  '/order-confirmation': 'Order Confirmed | Tribal Dash',
  '/customer/login': 'Sign In | Tribal Dash',
  '/customer/orders': 'My Orders | Tribal Dash',
  '/admin/login': 'Admin Login | Tribal Dash',
  '/admin/dashboard': 'Admin Dashboard | Tribal Dash',
  '/driver/login': 'Driver Login | Tribal Dash',
  '/driver/signup': 'Driver Sign Up | Tribal Dash',
  '/driver/agreement': 'Driver Agreement | Tribal Dash',
  '/driver/dashboard': 'Driver Dashboard | Tribal Dash',
};

/**
 * Keeps document.title in sync with the route so the browser tab always shows Tribal Dash
 * (avoids stale titles from cache or older index.html).
 */
export default function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = TITLES[pathname] || DEFAULT_TITLE;
  }, [pathname]);

  return null;
}
